/**
 * <ToggleSwitch />
 *
 *
 * @parent anybody
 * @stateful
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import Select from 'react-select';
import Switch from 'react-toggle-switch'
import './ToggleSwitch.scss';

export function toggleswitch(props) {
  const {
    value,
    onChange,
    schema,
    options,
  } = props;

  const {
    name,
  } = schema;

  // ui:options: { disabled: true }
  const {
    disabled,
  } = options;
  
  return (
    <ToggleSwitch 
      name={name}
      value={value}
      onChange={onChange}
      disabled={disabled}
    />
  );
}

class ToggleSwitch extends React.Component {
  static propTypes = {

  }

  constructor(props) {
    super(props);
  }

  render() {
    const {
      name,
      value,
      onChange,
      disabled,
    } = this.props

    return (
      <div className='react-toggle-switch form-input'>
        <Switch
          name={name}
          on={value == true}
          onClick={()=>{ 
            onChange(value == false);
          }}
          enabled={disabled !== true}
        />
      </div>
    ) 
  }
}

export default ToggleSwitch;



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/ToggleSwitch/index.js